<template>
  <UiInputTextFieldVeeBase v-bind="{ ...$props, ...$attrs }">
    <template
      v-for="(_, name) in $slots"
      :key="name"
      #[name]="slotData">
      <slot
        :name="name"
        v-bind="slotData ?? {}" />
    </template>
  </UiInputTextFieldVeeBase>
</template>

<script lang="ts">
import type { PropType } from 'vue'
import type { TValidationRules } from '@team-milva/lab-components'

export default {
  name: 'UiInputTextFieldVee',
  inheritAttrs: false,
  props: {
    name: { type: String, required: true as const },
    label: { type: String, default: undefined },
    rules: { type: Array as PropType<TValidationRules[]>, default: undefined },
    modelValue: { type: String, required: true as const },
    type: { type: String, default: undefined },
    placeholder: { type: String, default: undefined },
    // Not 'off': Chromium browsers (Chrome, Edge) ignore it on fields that look like an
    // address and still offer to save them — wrong here, where every order has a different
    // address. An unrecognised token stops the field being classified. Fields that want real
    // autofill (login, sign-up) pass their own token explicitly.
    autocomplete: { type: String, default: 'nope' },
    maxLength: { type: Number, default: undefined },
    showAsRequired: { type: Boolean, default: undefined },
    isRequired: { type: Boolean, default: undefined },
    isDisabled: { type: Boolean, default: undefined },
    isReadOnly: { type: Boolean, default: undefined },
    validateOnInput: { type: Boolean, default: undefined },
    hasClearButton: { type: Boolean, default: undefined },
    options: { type: Array as PropType<string[]>, default: undefined },
    unit: { type: String, default: undefined },
    hint: { type: String, default: undefined },
  },
}
</script>

